import { ConfigurationService } from './configuration.service';
import { HttpOptionsHelper } from '../helper/http-options.helper';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SubscriptionProduct } from '../models/subscription-product';
import { EnabledFeatureToggles } from '../models/enabled-feature-toggles';
import { Observable, BehaviorSubject } from 'rxjs';
import { skipWhile } from 'rxjs/operators';
import { AppInsightsConfiguration } from '../interfaces/app-insights-configuration';

@Injectable({ providedIn: 'root' })
export class BaseApiService {
  private _enabledFeatureToggles: BehaviorSubject<EnabledFeatureToggles> = new BehaviorSubject<EnabledFeatureToggles>(null);
  private baseUrl?: string;

  /**
   *
   * @param baseUrl is required by Android/iOS applications - it's base URL of app for current environment
   */
  constructor(private httpClient: HttpClient,
              private configurationService: ConfigurationService) {}

  public getCurrentSubscriptionsProducts(): Promise<Array<SubscriptionProduct>> {
    return this.httpGet<Array<SubscriptionProduct>>('/api/base/current-subscriptions/products');
  }

  public isUserApplicationAdmin(): Promise<boolean> {
    return this.httpGet<boolean>('/api/base/is-user-app-admin');
  }

  public isUserApplicationAssigned(): Promise<boolean> {
    return this.httpGet<boolean>('/api/base/is-user-app-assigned');
  }

  public isUserApplicationAdminAssigned(): Promise<boolean> {
    return this.httpGet<boolean>('/api/base/is-user-app-admin-assigned');
  }

  public getEnabledFeatureToggles(): Observable<EnabledFeatureToggles> {
    if (!this._enabledFeatureToggles || !this._enabledFeatureToggles.value || this._enabledFeatureToggles.value.featureCodes.length === 0) {
      this.httpGet<EnabledFeatureToggles>('/api/base/enabled-feature-toggles')
        .then((response) => {
          this._enabledFeatureToggles.next(response);
        })
        .catch((error) => {
          this._enabledFeatureToggles.error(error);
        });
    }
    return this._enabledFeatureToggles.pipe(
      skipWhile((fc) => {
        return !fc;
      })
    );
  }

  public getApplicationInsightsConfiguration(): Promise<AppInsightsConfiguration> {
    return this.httpGet<AppInsightsConfiguration>('/api/base/configurations/appinsights');
  }

  public getTenantRegistrationType(): Promise<string> {
    return this.httpGet<string>('/api/base/tenant-registration-type');
  }

  private async httpGet<T>(urlPath: string): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const config = this.configurationService.getConfiguration();
      this.baseUrl = config ? config.baseUrl : null;
      const suffixUrl = urlPath;
      const url = this.baseUrl ? `${this.baseUrl}${suffixUrl}` : suffixUrl;
      this.httpClient.get<T>(url, HttpOptionsHelper.getOptions())
        .subscribe((result) => {
          resolve(result);
        }, (error) => {
          reject(error);
        });
    });
  }
}
